export class PersonalInformation {
  constructor(
    public first_name?: string,
    public last_name?: string,
    public mail?: string,
    public password?: string
  ) {}
  [key: string]: any;
}

export class BusinessInformation {
  constructor(
    public name?: string,
    public address?: string,
    public ein?: string,
    public addressAdditional?: string,
    public type?: string,
    public city?: string,
    public state?: string,
    public zip?: string,
    public phone?: string | null,
    public phoneCountryCode?: string,
    public phoneCountryIso?: string,
    public website?: string,
    public preloadedBusinessData?: {
      businessId: string;
    }
  ) {}
  [key: string]: any;
}
export class AllInformation {
  constructor(
    public PersonalInformation: PersonalInformation,
    public BusinessInformation: BusinessInformation
  ) {}
}

export const sessionKey = 'signup-steps';
